import { storageInit } from 'redux/reducers/init';
import {
  requestStorageList,
  requestStorageListFailure,
  requestStorageListSuccess,
} from 'redux/actions/actions';

import { createReducer } from '@reduxjs/toolkit';

const storage = createReducer(storageInit, {
  [requestStorageList.type]: (state, action) => {
    state.isLoading = true;
  },
  [requestStorageListSuccess.type]: (state, action) => {
    const { storageList } = action.payload;
    state.isInit = true;
    state.isLoading = false;
    state.storageList = storageList;
  },
  [requestStorageListFailure.type]: (state, action) => {
    state.isInit = false;
    state.isLoading = false;
    state.storageList = [];
  },
});

export default storage;
